
export const NEPAL_TIME_ZONE = 'Asia/Kathmandu';


export const formatDateDDMMYYYY = (dateString) => {
  const d = new Date(dateString);
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: NEPAL_TIME_ZONE,
    day: '2-digit', month: '2-digit', year: 'numeric'
  }).formatToParts(d);
  const get = (type) => parts.find(p => p.type === type).value;
  return `${get('day')}-${get('month')}-${get('year')}`;
};

// 'today' / 'first of month' must be Nepal's calendar date, not whatever the
// viewing device's own timezone says — otherwise default date ranges (and the
// min/max bounds tied to them) silently drift for anyone checking the
// dashboard from a device not set to Asia/Kathmandu. Shared by every page
// that needs a default range; keep it here rather than re-deriving per page.
const nepalDateParts = (date) => {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: NEPAL_TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit'
  }).formatToParts(date);
  const get = (type) => parts.find(p => p.type === type).value;
  return { year: get('year'), month: get('month'), day: get('day') };
};

export const todayStr = () => {
  const { year, month, day } = nepalDateParts(new Date());
  return `${year}-${month}-${day}`;
};

export const firstOfMonthStr = () => {
  const { year, month } = nepalDateParts(new Date());
  return `${year}-${month}-01`;
};
